import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomainDetailComponent } from '@app/modules/domains/pages/domain-detail/domain-detail.component';
import { DomainsListComponent } from '@app/modules/domains/pages/domains-list/domains-list.component';
import { DomainsWizardComponent } from '@app/modules/domains/pages/domains-wizard/domains-wizard.component';
import { SharedModule } from '@app/shared/shared.module';
import { DomainsRoutingModule } from './domains-routing.module';

@NgModule({
  imports: [CommonModule, DomainsRoutingModule, SharedModule],
  declarations: [DomainsListComponent, DomainsWizardComponent, DomainDetailComponent],
})
export class DomainsModule {}
